// import { SECRET_KEY } from "Config";

import { isEmpty } from "lodash";

export const getUnits = () => "Points"

export const pluralize = (count, noun, suffix = 's') => `${count} ${noun}${count !== 1 ? suffix : ''}`;

export function formatNumberWithCurrency(number, currency = "INR") {
    const value = parseFloat(number).toLocaleString("en-IN", {
        style: "currency",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        currency: currency,
    });
    return value.replace(/([^\d])(\d)/, "$1 $2")
}

export function formatNumber(number) {
    return parseFloat(number).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export const StorageProvider = {
    set: (key, data) => {
        // const data = CryptoJS.AES.encrypt(JSON.stringify(rawData), SECRET_KEY).toString()
        localStorage.setItem(key, JSON.stringify(data))
    },
    get: (key) => {
        const storedData = localStorage.getItem(key)
        if (storedData) {
            // const bytes = CryptoJS.AES.decrypt(storedData, key);
            // return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return JSON.parse(storedData)
        }
        return null
    },
    remove: (key) => localStorage.removeItem(key),
}

export const getTotal = (qty, splrate, dealerrate) => {
    if (isEmpty(splrate) || !isNaN(splrate) || Number(splrate) === 0) {
        return Number(qty) * Number(dealerrate)
    }

    return Number(qty) * Number(splrate)
}

export const highlightText = (text = '', search = '') => {
    if (isEmpty(search)) {
        return text
    }
    // Escape special characters in the search term for regex
    const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    // Create a regex to find the search term, case insensitive
    const regex = new RegExp(`(${escapedSearch})`, "gi");

    // Split the text into parts based on the search term
    const parts = text.split(regex);

    return (
        <span>
            {parts.map((part, index) =>
                regex.test(part) ? (
                    <span key={index} className="bg-yellow-200 text-black font-semibold">
                        {part}
                    </span>
                ) : (
                    <span key={index}>{part}</span>
                )
            )}
        </span>
    )
}